module.exports = __webpack_public_path__ + "img/sierras-le_mclaren.d40e2e7.png";